import { AppState } from "src/app/redux/app.state";

// !Only use this if you are sure the store partition exists (this section of store is lazy loaded)
export const templateInstallationRequests = (state: AppState) => state.templateInstallationRequests
